import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';

import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';
import {
  SSDateAdapter,
  SSDateParserFormatter,
} from '@shared/components/date-picker/ss-date-adapter';
import { SSDatepickerI18n } from '@shared/components/date-picker/ss-datepicker-i18n';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { mockHttpInterceptor } from './core/interceptors/mock-http.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),

    // Config Core HTTP
    provideHttpClient(
      withFetch(),
      withInterceptors([
        mockHttpInterceptor,
        authInterceptor,
        errorInterceptor,
      ]),
    ),

    // Hệ thống Đa ngôn ngữ
    provideTranslateService({
      fallbackLang: environment.defaultLanguage,
    }),
    provideTranslateHttpLoader({
      prefix: './i18n/',
      suffix: '.json',
    }),

    // Config DatePicker
    {
      provide: NgbDateAdapter,
      useClass: SSDateAdapter,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: SSDateParserFormatter,
    },
    {
      provide: NgbDatepickerI18n,
      useClass: SSDatepickerI18n,
    },
  ],
};
